import React, { Component } from 'react';
import { confirmEmail } from './ducks/actions';
import { connect } from 'react-redux';
import { Alert } from 'react-bootstrap';
import './style.css';
import logo from '../../../images/login-logo@1x.png';
class ConfirmEmail extends Component {
  componentDidMount() {
    this.props.actions.confirmEmail(this.props.match.params.token);
  }

  handleSubmit(event) {
    event.preventDefault();
    if (this.isValid()) {
      this.props.actions.confirmEmail(this.props.match.params.token);
    }
  }

  render() {
    var body = <div className="panel-body" />;
    if (this.props.error) {
      body = (
        <div className="panel-body">
          <Alert bsStyle="danger">
            This email verification link is invalid or has expired.
          </Alert>
          <p>
            You may need to contact your administrator to be issued a new
            invitation.
          </p>
        </div>
      );
    }

    if (this.props.email) {
      body = (
        <div className="panel-body">
          <Alert bsStyle="success">
            Email address successfully changed to: {this.props.email}
          </Alert>
          <p>Your email address is used for password reset.</p>
          <a href="/">Login to ComputerEase Employee Hub</a>
        </div>
      );
    }
    return (
      <div>
        <div className="main-wrapper">
          <div className="panel panel-default">
            <div className="panel-heading">
              <img src={logo} alt="ComputerEase" />
              <h3 className="panel-title">Employee Hub</h3>
            </div>
            {body}
          </div>
          <p className="small footer-notes">
            <strong>
              Copyright © {new Date().getFullYear()} Deltek, Inc.<br />All
              rights reserved.<br />
              <a
                href="https://www.deltek.com/en/legal.aspx"
                target="privacy_policy"
                class="white"
              >
                Privacy Policy
              </a>
            </strong>
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    error: state.confirmNewEmailReducer.error,
    success: state.confirmNewEmailReducer.success,
    email: state.confirmNewEmailReducer.email
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: {
      confirmEmail: token => {
        dispatch(confirmEmail(token));
      }
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmail);



// WEBPACK FOOTER //
// ./src/components/account/ConfirmNewEmail/index.js